import { ACTION_TYPES } from '../state-areas/navigation/constants';

const navigationMiddleware = store => {
  let navigate;

  return next => action => {
    switch (action.type) {
      case ACTION_TYPES.INITIALIZE_NAVIGATION_MIDDLEWARE: {
        navigate = action.payload;
        break;
      }
      case ACTION_TYPES.NAVIGATE: {
        if (navigate) {
          navigate(action.payload.route);
        } else {
          console.warn('[navigationMiddleware]: navigate method is not initialized yet')
        }
        break;
      }
      default: {
        return next(action);
      }
    }
  }
};

export default navigationMiddleware;
